// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-content{
    position: relative;
    display: block;
    flex-wrap: wrap;
    margin-top: 8%;
    width: 100%;
    height: -moz-fit-content;
    height: fit-content;
    font-size: 1rem;
    scroll-snap-align: start;
}

.cont i{
    margin-right: 10px;
}

.about-content::-webkit-scrollbar{display: none;}

.about-content{
    .card{
        display: flex;
        position: absolute;
        margin-top: -290px;
        margin-left: 90px;
        width: 400px;
        height: 220px;
        margin-bottom: 2rem;
        box-shadow: 4px 4px 12px -5px var(--text-color);
        border-radius: 15px;
        background: rgb(255, 255, 255, 0.1);
        /* overflow: hidden; */
        border-top: 1px solid var(--text-color);
        border-left: 1px solid var(--text-color);
        -webkit-backdrop-filter: blur(3px);
                backdrop-filter: blur(3px);
        animation: anime 1.3s infinite ease-in-out alternate;
        -webkit-animation: anime 1.3s infinite ease-in-out alternate;
        z-index: 100;
      }
}

@keyframes anime {
    100%{
        transform: translateY(10px);
        -webkit-transform: translateY(10px);
        -webkit-transform: translateY(10px);
        -moz-transform: translateY(10px);
        -ms-transform: translateY(10px);
        -o-transform: translateY(10px);
    }
}

.about-content{
    .card img{
        position: absolute;
        display:inline-flex;
        margin-top: 15px;
        margin-left: 330px;
        width: 50px;
        height: 45px;
    }
}

.about-content{
    .card h1{
        position: absolute;
        display: inline-flex;
        margin-top: 35px;
        margin-left: 25px;
        color: var(--main-color);
    }
}

.about-content{
    .card h2{
        position: absolute;
        display:inline-flex;
        margin-top: 80px;
        font-size: 1.2rem;
        font-weight: 600;
        margin-left: 26px;
        color: var(--text-color);
        text-decoration:underline;
    }
}

.about-content{
    .card h3{
        position: absolute;
        display:inline-flex;
        margin-top: 120px;
        font-size: 0.8rem;
        font-weight: 600;
        margin-left: 26px;
        color: var(--text-color);
    }
}

.about-content{
    .card h4{
    position: absolute;
    display:inline-flex;
    margin-top: 135px;
    font-size: 0.8rem;
    font-weight: 600;
    margin-left: 26px;
    color: var(--text-color);
}
}

.about-content{
    .card p{
        position: absolute;
        display:inline-flex;
        margin-top: 180px;
        margin-left: 23px;
        color: var(--text-color);
        text-decoration:underline;
    }
}

.cont{
    text-align: justify;
    display: flex;
    width: 93%;
    flex-wrap: wrap;
}

.about-content .heading{
    justify-self: left;
    text-align: left;
    font-size: 2.5rem;
    margin: 1rem 1rem 1rem 35rem;
}

.about-content h2{
    text-align: left;
    line-height: 1.5;
}

.about-content p{
    /* margin: 2rem ; */
    width: 100%;
    margin: 1rem 1rem 1rem 35rem;
}

.about-content{
    .btn {
    display: inline-block;
    padding: 0.7rem 2rem;
    color: var(--text-color);
    background: var(--main-color);
    border-radius: 4rem;
    box-shadow: 0 0 0.5rem var(--text-color);
    width: -moz-fit-content;
    width: fit-content;
    font-size: 1.6rem;
    letter-spacing: .1rem;
    font-weight: 600;
    transition: 0.5s ease;
    margin: 1rem 1rem 1rem 35rem;

}
}
.about-content{
    .btn:hover{
    box-shadow: none;
    color: var(--main-color);
    background-color: var(--text-color);
}
}

@media (max-width:998px){

    .about-content{
        display: flex;
        height: -moz-fit-content;
        height: fit-content;
        margin-top: 0%;
        overflow: hidden;
        align-items: center;
        justify-content: center;
    }

    .cont{
        width: 98%;
        margin-top: 12%;
        margin-left: 0;
        align-items: center;
        justify-content: center;
    }

    .about-content{
        .card{
            position: relative;
            align-self: center;
            margin-top: 10px;
            margin-left: 0px;
            width: 355px;
            height: 210px;
            justify-self: center;
            /* margin: 5rem 0rem 0rem 0.8rem; */
        }
    }

    .about-content{
        .card img{
            margin-top: 15px;
            margin-left: 300px;
            width: 40px;
            height: 35px;
        }
    }
    
    .about-content{
        .card h1{
            font-size: 1.8rem;
            margin-top: 30px;
            margin-left: 20px;
        }
    }

    .about-content{
        .card h2{
            margin-top: 80px;
            font-size: 1.1rem;
            margin-left: 21px; 
        }
    }

    .about-content{
        .card h3{
            margin-top: 125px;
            margin-left: 21px;
        }
    }

    .about-content{
        .card h4{
            margin-top: 140px;
            margin-left: 21px;
        }
    }

    .about-content{
        .card p{
            font-size: 0.9rem;
            margin-top: 180px;
            margin-left: 15px;
        }}

    .about-content .heading{
        margin: 1rem 0rem 1.5rem 0rem;
    }

    .cont p{
        margin: 0rem 1.2rem 1rem 1.2rem;
    }

    .about-content{
        .btn {
            margin: 1.5rem 0rem 1.5rem 0rem ;
        }
    }
}`, "",{"version":3,"sources":["webpack://./src/components/About/AboutMe/AboutMe.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,wBAAmB;IAAnB,mBAAmB;IACnB,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;AACtB;;AAEA,kCAAkC,aAAa,CAAC;;AAEhD;IACI;QACI,aAAa;QACb,kBAAkB;QAClB,kBAAkB;QAClB,iBAAiB;QACjB,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,+CAA+C;QAC/C,mBAAmB;QACnB,mCAAmC;QACnC,sBAAsB;QACtB,uCAAuC;QACvC,wCAAwC;QACxC,kCAA0B;gBAA1B,0BAA0B;QAC1B,oDAAoD;QACpD,4DAA4D;QAC5D,YAAY;MACd;AACN;;AAEA;IACI;QACI,2BAA2B;QAC3B,mCAAmC;QACnC,mCAAmC;QACnC,gCAAgC;QAChC,+BAA+B;QAC/B,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,mBAAmB;QACnB,gBAAgB;QAChB,kBAAkB;QAClB,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,oBAAoB;QACpB,gBAAgB;QAChB,iBAAiB;QACjB,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,iBAAiB;QACjB,wBAAwB;QACxB,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,mBAAmB;QACnB,iBAAiB;QACjB,iBAAiB;QACjB,gBAAgB;QAChB,iBAAiB;QACjB,wBAAwB;IAC5B;AACJ;;AAEA;IACI;IACA,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;AAC5B;AACA;;AAEA;IACI;QACI,kBAAkB;QAClB,mBAAmB;QACnB,iBAAiB;QACjB,iBAAiB;QACjB,wBAAwB;QACxB,yBAAyB;IAC7B;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI;IACA,qBAAqB;IACrB,oBAAoB;IACpB,wBAAwB;IACxB,6BAA6B;IAC7B,mBAAmB;IACnB,wCAAwC;IACxC,uBAAkB;IAAlB,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;IAChB,qBAAqB;IACrB,4BAA4B;;AAEhC;AACA;AACA;IACI;IACA,gBAAgB;IAChB,wBAAwB;IACxB,mCAAmC;AACvC;AACA;;AAEA;;IAEI;QACI,aAAa;QACb,wBAAmB;QAAnB,mBAAmB;QACnB,cAAc;QACd,gBAAgB;QAChB,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI,UAAU;QACV,eAAe;QACf,cAAc;QACd,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI;YACI,kBAAkB;YAClB,kBAAkB;YAClB,gBAAgB;YAChB,gBAAgB;YAChB,YAAY;YACZ,aAAa;YACb,oBAAoB;YACpB,mCAAmC;QACvC;IACJ;;IAEA;QACI;YACI,gBAAgB;YAChB,kBAAkB;YAClB,WAAW;YACX,YAAY;QAChB;IACJ;;IAEA;QACI;YACI,iBAAiB;YACjB,gBAAgB;YAChB,iBAAiB;QACrB;IACJ;;IAEA;QACI;YACI,gBAAgB;YAChB,iBAAiB;YACjB,iBAAiB;QACrB;IACJ;;IAEA;QACI;YACI,iBAAiB;YACjB,iBAAiB;QACrB;IACJ;;IAEA;QACI;YACI,iBAAiB;YACjB,iBAAiB;QACrB;IACJ;;IAEA;QACI;YACI,iBAAiB;YACjB,iBAAiB;YACjB,iBAAiB;QACrB,CAAC;;IAEL;QACI,6BAA6B;IACjC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI;YACI,gCAAgC;QACpC;IACJ;AACJ","sourcesContent":[".about-content{\n    position: relative;\n    display: block;\n    flex-wrap: wrap;\n    margin-top: 8%;\n    width: 100%;\n    height: fit-content;\n    font-size: 1rem;\n    scroll-snap-align: start;\n}\n\n.cont i{\n    margin-right: 10px;\n}\n\n.about-content::-webkit-scrollbar{display: none;}\n\n.about-content{\n    .card{\n        display: flex;\n        position: absolute;\n        margin-top: -290px;\n        margin-left: 90px;\n        width: 400px;\n        height: 220px;\n        margin-bottom: 2rem;\n        box-shadow: 4px 4px 12px -5px var(--text-color);\n        border-radius: 15px;\n        background: rgb(255, 255, 255, 0.1);\n        /* overflow: hidden; */\n        border-top: 1px solid var(--text-color);\n        border-left: 1px solid var(--text-color);\n        backdrop-filter: blur(3px);\n        animation: anime 1.3s infinite ease-in-out alternate;\n        -webkit-animation: anime 1.3s infinite ease-in-out alternate;\n        z-index: 100;\n      }\n}\n\n@keyframes anime {\n    100%{\n        transform: translateY(10px);\n        -webkit-transform: translateY(10px);\n        -webkit-transform: translateY(10px);\n        -moz-transform: translateY(10px);\n        -ms-transform: translateY(10px);\n        -o-transform: translateY(10px);\n    }\n}\n\n.about-content{\n    .card img{\n        position: absolute;\n        display:inline-flex;\n        margin-top: 15px;\n        margin-left: 330px;\n        width: 50px;\n        height: 45px;\n    }\n}\n\n.about-content{\n    .card h1{\n        position: absolute;\n        display: inline-flex;\n        margin-top: 35px;\n        margin-left: 25px;\n        color: var(--main-color);\n    }\n}\n\n.about-content{\n    .card h2{\n        position: absolute;\n        display:inline-flex;\n        margin-top: 80px;\n        font-size: 1.2rem;\n        font-weight: 600;\n        margin-left: 26px;\n        color: var(--text-color);\n        text-decoration:underline;\n    }\n}\n\n.about-content{\n    .card h3{\n        position: absolute;\n        display:inline-flex;\n        margin-top: 120px;\n        font-size: 0.8rem;\n        font-weight: 600;\n        margin-left: 26px;\n        color: var(--text-color);\n    }\n}\n\n.about-content{\n    .card h4{\n    position: absolute;\n    display:inline-flex;\n    margin-top: 135px;\n    font-size: 0.8rem;\n    font-weight: 600;\n    margin-left: 26px;\n    color: var(--text-color);\n}\n}\n\n.about-content{\n    .card p{\n        position: absolute;\n        display:inline-flex;\n        margin-top: 180px;\n        margin-left: 23px;\n        color: var(--text-color);\n        text-decoration:underline;\n    }\n}\n\n.cont{\n    text-align: justify;\n    display: flex;\n    width: 93%;\n    flex-wrap: wrap;\n}\n\n.about-content .heading{\n    justify-self: left;\n    text-align: left;\n    font-size: 2.5rem;\n    margin: 1rem 1rem 1rem 35rem;\n}\n\n.about-content h2{\n    text-align: left;\n    line-height: 1.5;\n}\n\n.about-content p{\n    /* margin: 2rem ; */\n    width: 100%;\n    margin: 1rem 1rem 1rem 35rem;\n}\n\n.about-content{\n    .btn {\n    display: inline-block;\n    padding: 0.7rem 2rem;\n    color: var(--text-color);\n    background: var(--main-color);\n    border-radius: 4rem;\n    box-shadow: 0 0 0.5rem var(--text-color);\n    width: fit-content;\n    font-size: 1.6rem;\n    letter-spacing: .1rem;\n    font-weight: 600;\n    transition: 0.5s ease;\n    margin: 1rem 1rem 1rem 35rem;\n\n}\n}\n.about-content{\n    .btn:hover{\n    box-shadow: none;\n    color: var(--main-color);\n    background-color: var(--text-color);\n}\n}\n\n@media (max-width:998px){\n\n    .about-content{\n        display: flex;\n        height: fit-content;\n        margin-top: 0%;\n        overflow: hidden;\n        align-items: center;\n        justify-content: center;\n    }\n\n    .cont{\n        width: 98%;\n        margin-top: 12%;\n        margin-left: 0;\n        align-items: center;\n        justify-content: center;\n    }\n\n    .about-content{\n        .card{\n            position: relative;\n            align-self: center;\n            margin-top: 10px;\n            margin-left: 0px;\n            width: 355px;\n            height: 210px;\n            justify-self: center;\n            /* margin: 5rem 0rem 0rem 0.8rem; */\n        }\n    }\n\n    .about-content{\n        .card img{\n            margin-top: 15px;\n            margin-left: 300px;\n            width: 40px;\n            height: 35px;\n        }\n    }\n    \n    .about-content{\n        .card h1{\n            font-size: 1.8rem;\n            margin-top: 30px;\n            margin-left: 20px;\n        }\n    }\n\n    .about-content{\n        .card h2{\n            margin-top: 80px;\n            font-size: 1.1rem;\n            margin-left: 21px; \n        }\n    }\n\n    .about-content{\n        .card h3{\n            margin-top: 125px;\n            margin-left: 21px;\n        }\n    }\n\n    .about-content{\n        .card h4{\n            margin-top: 140px;\n            margin-left: 21px;\n        }\n    }\n\n    .about-content{\n        .card p{\n            font-size: 0.9rem;\n            margin-top: 180px;\n            margin-left: 15px;\n        }}\n\n    .about-content .heading{\n        margin: 1rem 0rem 1.5rem 0rem;\n    }\n\n    .cont p{\n        margin: 0rem 1.2rem 1rem 1.2rem;\n    }\n\n    .about-content{\n        .btn {\n            margin: 1.5rem 0rem 1.5rem 0rem ;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
